import React from 'react';
import './style.scss';
import StepZero from '../../components/Seggregation/StepZero';

const Seggregation = () =>{
    return(
        <div className='seggregation_wrapper'>
            <StepZero/>
        </div>
    )
}

export default Seggregation;